// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'newspaper-fold';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M17.438 4.5v10.688a1.687 1.687 0 0 1-1.688 1.687m0 0a1.687 1.687 0 0 1-1.688-1.688V2.25a1.125 1.125 0 0 0-1.125-1.125H1.687A1.125 1.125 0 0 0 .562 2.25v12.938a1.687 1.687 0 0 0 1.688 1.687zM3.375 11.25h7.875M3.375 13.5h4.5' />
    <path d='M3.375 3.938h7.875v4.5H3.375z' />
  </g>
);

export const viewBox = '0 0 18 18';
